var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaderboard-users",attrs:{"id":"leaderboard-users"}},[(_vm.loading)?_c('SpinLoader'):_vm._e(),(!_vm.loading)?[_c('TopUsers',{attrs:{"users":_vm.users.top}}),_c('UserList',{attrs:{"users":_vm.userArray,"top":_vm.users.top}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }